export default "__VITE_ASSET__frItpphs__"